/**
 * Allowlist of baked-in theme variants. Adding a new variant requires:
 *   (a) appending the name here, and
 *   (b) adding a matching CSS block in resources/widget/styles/widget.css.
 *
 * Keep names kebab-case to match HTML attribute conventions.
 */
export const VARIANTS = ['light', 'dark', 'moongroup-space', 'moongroup-space-image'];

/**
 * Variant used when none is passed, or when an invalid one is passed.
 * "dark" is the truly-neutral portable preset — safe on any host.
 */
export const DEFAULT_VARIANT = 'dark';

/**
 * Stamp `data-variant="..."` on the widget host element so the matching CSS
 * variant block applies.
 *
 *   - undefined/null  → silently uses DEFAULT_VARIANT (normal path)
 *   - invalid value   → warns once, uses DEFAULT_VARIANT
 *   - valid string    → uses it as-is
 *
 * Never throws. The widget is embedded on third-party pages, so we warn loudly
 * but always render.
 */
export function applyVariant(host, variant) {
    if (variant != null && !VARIANTS.includes(variant)) {
        console.warn(
            `[AIWidget] Unknown variant "${variant}". Falling back to "${DEFAULT_VARIANT}". Valid: ${VARIANTS.join(', ')}`,
        );
    }
    const safe = VARIANTS.includes(variant) ? variant : DEFAULT_VARIANT;
    host.setAttribute('data-variant', safe);
}
